import { PropsWithChildren } from 'react';
import { useParams } from 'react-router';

import { ProtectedRoute as Protected, ROUTE } from '@app-evolution-cms/router';

import { RoleClaim } from '../../users/_types/role-claim';
import { useHasPermission } from './use-has-permission';

interface ProtectedRouteProps {
  fallbackPath?: string;
  roles: RoleClaim[];
}

export function ProtectedRoute({
  children,
  fallbackPath,
  roles,
}: PropsWithChildren<ProtectedRouteProps>) {
  const { moduleId } = useParams();
  const hasPermission = useHasPermission({ roles });

  return (
    <Protected
      fallbackPath={fallbackPath ?? ROUTE.modulesContent.main.replace(':moduleId', moduleId ?? '')}
      hasPermission={hasPermission}
    >
      {children}
    </Protected>
  );
}
